import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.subscription_renewal';
export const Component = loadable(
  () => import('./containers/SubscriptionRenewalContainer')
);
export { default as propsFormatter } from './propsFormatter';
